import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  ButtonAdd,
  ButtonUploadArch,
  ContainerButton,
  CreatableSelectInput,
  Form,
  Input,
  SelectInput,
  TextTitle,
  Textarea,
  Title,
} from "../../../styles/global";
import Panel from "../../../components/Panel";
import Radio from "../../../components/InputRadio";
import { Button, Container } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faX } from "@fortawesome/free-solid-svg-icons";
import useOrgao from "../../../actions/cruds/useOrgao";
import useDespesas from "../../../actions/cruds/useDespesas";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, useParams } from "react-router-dom";
import { FormHandles } from "@unform/core";
import useProtocolo from "../../../actions/cruds/Protocolo/useProtocolo";
import organizeDataSelect from "../../../utils/organizeDataSelect";
import api from "../../../services/api";
import useSolicitanteExterno from "../../../actions/cruds/Protocolo/useSolicitanteExterno";
import { GridColDef } from "@mui/x-data-grid";
import SecondaryTable from "../../../components/SecondaryTable";
import useOrigemDemanda from "../../../actions/cruds/Protocolo/useOrigemDemanda";
import InputFilev2 from "../../../components/InputFilev2";
import useComite from "../../../actions/cruds/useComite";
import useInstanciaProtocolo from "../../../actions/cruds/Protocolo/useInstanciaProtocolo";
import { useAuth } from "../../../hooks/auth";
import getPermission from "../../../utils/getPermission";

const demanda_options = [
  { label: "Interno", value: "interno" },
  { label: "Externo", value: "externo" },
];

const rateio_options = [
  { label: "Sim", value: true },
  { label: "Não", value: false },
];

const situacao_options = [
  { label: "Não iniciado", value: "nao_iniciado", id: "001" },
  { label: "Em andamento", value: "em_andamento", id: "002" },
  { label: "Concluído", value: "concluido", id: "003" },
];

const ProtocoloEdit: React.FC = () => {
  const { orgaos, getOrganizations } = useOrgao();
  const { despesas, getDespesas } = useDespesas();
  const { getSolicitantesExternos, solicitantesExternos } = useSolicitanteExterno();
  const { protocolo, getProtocolo, getTiposEncaminhamento, tiposEncaminhamento, getSolicitantesProtocolo, solicitantesProtocolo, updateProtocolo } = useProtocolo();
  const { origensDemanda, getOrigensDemanda } = useOrigemDemanda();
  const { comites, getComittees } = useComite();
  const { instanciasProtocolo, getInstanciasProtocolo } = useInstanciaProtocolo();

  const { protocoloId } = useParams();

  const { login } = useAuth();
  const protocoloPermission = getPermission(login,"Protocolo");
  const isVisitante = protocoloPermission == "Visitante";

  const [estimativaDatas, setEstimativaDatas] = useState({
    dataInicio: "",
    dataFim: "",
  });
  const [valueLocal, setValueLocal] = useState<Object>();
  const [solicitante, setSolicitante] = useState<Object>();
  const [origemSolicitante, setOrigemSolicitante] = useState<String>();
  const [origemSolicitanteInicial, setOrigemSolicitanteInicial] = useState<String>();
  const [comite, setComite] = useState<Object>();
  const [usuariosByCargo, setUsuariosByCargo] = useState([]);
  const [documentoDemanda, setDocumentoDemanda] = useState<Object>();
  const [solicitanteComitesFront, setSolicitanteComitesFront] = useState<Array<Object>>([]);
  const [solicitanteComitesBack, setSolicitanteComitesBack] = useState<Array<Object>>([]);
  const [solicitanteComitesInitial, setSolicitanteComitesInitial] = useState<Array<Object>>([]);

  const getUsuariosByCargo = (nome?: string) => {
    api
      .get(`users?cargo_gerente_assessor=true&nome=${nome}&ativo=true`)
      .then((response) => setUsuariosByCargo(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getProtocolo(protocoloId);
    getOrganizations([{ label: 'ativo', value: true }]);
    getDespesas([{ label: 'ativo', value: true }]);
    getTiposEncaminhamento([{ label: 'ativo', value: true }]);
    getOrigensDemanda([{ label: 'ativo', value: true }]);
    getSolicitantesExternos([{ label: 'ativo', value: true }]);
    getComittees([{ label: 'ativo', value: true }]);
    getSolicitantesProtocolo([{ label: 'ativo', value: true }]);
    getInstanciasProtocolo([{ label: 'ativo', value: true }]);
    getUsuariosByCargo("");

  }, []);

  useEffect(() => {
    if (protocolo.id) {
      setValueLocal(protocolo?.local);

      const localOrigemRadio = formRef.current?.getFieldRef("local");
      if (protocolo?.local == 'interno') {
        localOrigemRadio[0].checked = true;
      } else if (protocolo?.local == 'externo') {
        localOrigemRadio[1].checked = true;
      };

      // const rateioRadio = formRef.current?.getFieldRef("rateio");
      // if (protocolo?.rateio == true) {
      //   rateioRadio[0].checked = true;
      // } else if (protocolo?.rateio == false) {
      //   rateioRadio[1].checked = true;
      // }

      formRef.current?.setFieldValue("data_entrada", protocolo?.data_entrada);
      formRef.current?.setFieldValue("organization_id", { value: protocolo?.organization?.id, label: `${protocolo?.organization?.codigo} - ${protocolo?.organization?.nome}` });
      formRef.current?.setFieldValue("expense_type_id", { value: protocolo?.expense_type?.id, label: `${protocolo?.expense_type?.codigo} - ${protocolo?.expense_type?.nome}` });
      formRef.current?.setFieldValue("comittee_id", { value: protocolo?.institution_competence?.comittee?.id, label: protocolo?.institution_competence?.comittee?.nome });
      formRef.current?.setFieldValue("instance_id", { value: protocolo?.institution_competence?.instance?.id, label: protocolo?.institution_competence?.instance?.nome });
      formRef.current?.setFieldValue("demand_origin_id", { value: protocolo?.demand_origin?.id, label: protocolo?.demand_origin?.nome });
      formRef.current?.setFieldValue("protocol_instance_id", protocolo?.protocol_instance ? { value: protocolo?.protocol_instance?.id, label: protocolo?.protocol_instance?.nome } : '');
      formRef.current?.setFieldValue("forwarding_type_id", { value: protocolo?.forwarding_type?.id, label: `${protocolo?.forwarding_type?.codigo} - ${protocolo?.forwarding_type?.nome}` });
      formRef.current?.setFieldValue("situacao", { value: protocolo?.situacao, label: situacao_options?.find((situacao) => situacao?.value == protocolo?.situacao)?.label });
      formRef.current?.setFieldValue("user_id", { value: protocolo?.user?.id, label: protocolo?.user?.nome });
      setEstimativaDatas({ dataInicio: protocolo?.data_arquivo, dataFim: protocolo?.data_previsao_conclusao })
      setDocumentoDemanda({ id: protocolo?.id, titulo_arquivo: protocolo?.titulo_arquivo, data_arquivo: protocolo?.data_arquivo, nome_arquivo: protocolo?.nome_arquivo, url_arquivo: protocolo?.url_arquivo, isNew: false })
      formRef.current?.setFieldValue("observacao", protocolo?.observacao);
      // formRef.current?.setFieldValue("", {value: protocolo?., label: protocolo?.});
    }

  }, [protocolo])

  useEffect(() => {
    if (protocolo?.representative?.id) {
      setOrigemSolicitanteInicial("representatives")
    } else if (protocolo?.solicitante?.id) {
      setOrigemSolicitanteInicial("users");
    } else if (protocolo?.external_requester?.id) {
      setOrigemSolicitanteInicial("external");
    };
  }, [valueLocal])


  useEffect(() => {
    if (origemSolicitanteInicial == 'representatives') {
      formRef.current?.setFieldValue("solicitante", { value: protocolo?.representative?.id, label: `${protocolo?.representative?.nome} - Representante`, nome: protocolo?.representative?.nome, tabela: 'representatives' });

      if (protocolo?.comittees.length > 0) {
        setSolicitanteComitesFront((prevSolicitanteComitesFront) => {
          return [
            ...prevSolicitanteComitesFront,
            ...protocolo.comittees.map((comitte) => ({
              id: comitte.id,
              solicitante: protocolo?.representative?.nome,
              origem: "Representante",
              comite: comitte.nome,
            })),
          ];
        });
        setSolicitanteComitesInitial(protocolo?.demand_comittees);
      }

    } else if (origemSolicitanteInicial == 'users') {
      formRef.current?.setFieldValue("solicitante", { value: protocolo?.solicitante?.id, label: `${protocolo?.solicitante?.nome} - Funcionário`, nome: protocolo?.solicitante?.nome, tabela: 'users' });

      if (protocolo?.comittees.length > 0) {
        setSolicitanteComitesFront((prevSolicitanteComitesFront) => {
          return [
            ...prevSolicitanteComitesFront,
            ...protocolo.comittees.map((comitte) => ({
              id: comitte.id,
              solicitante: protocolo?.solicitante?.nome,
              origem: "Funcionário",
              comite: comitte.nome,
            })),
          ];
        });
        setSolicitanteComitesInitial(protocolo?.demand_comittees);
      }

    } else if (origemSolicitanteInicial == 'external') {
      formRef.current?.setFieldValue("external_requester_id", { value: protocolo?.external_requester?.id, label: protocolo?.external_requester?.nome });
    }

  }, [origemSolicitanteInicial])

  const organizeDataSolicitanteExterno = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          value: d.id,
          label: d.nome,
          telefone: d.telefone,
          email: d.email,
          local: d.local
        }));
        return data;
      }
    }
    return [];
  };

  const organizeDataComCodigo = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          value: d.id,
          label: `${d.codigo} - ${d.nome}`,
        }));
        return data;
      }
    }
    return [];
  };

  const organizeDataSolicitante = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          value: d.id,
          label: `${d.nome} - ${d.tabela == 'representatives' ? "Representante" : "Funcionário"}`,
          nome: d.nome,
          tabela: d.tabela,
        }));
        return data;
      }
    }
    return [];
  };

  const organizeDataComittee = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          value: d.id,
          label: d.nome,
        }));
        return data;
      }
    }
    return [];
  };

  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: object) => {
      try {

        data["comittes_relation"] = "";
        data["solicitante_id"] = "";
        data["representative_id"] = "";
        if (valueLocal == 'interno') {
          data["external_requester_id"] = "";
          if (origemSolicitante == 'representatives') {
            data["representative_id"] = solicitante?.value;
          } else if (origemSolicitante == 'users') {
            data["solicitante_id"] = solicitante?.value;
          }

          if (solicitanteComitesFront.length == 0) {
            alert("Adicione Comitês ao Solicitante!");
            return;
          };
        };

        data["demand_comittees_attributes"] = solicitanteComitesBack;

        const dataEstimativaConclusao = formRef.current?.getFieldValue("data_previsao_conclusao");
        if (documentoDemanda.isNew) {
          data["titulo_arquivo"] = documentoDemanda.titulo_arquivo;
          data["data_arquivo"] = documentoDemanda.data_arquivo;
          data["nome_arquivo"] = documentoDemanda.nome_arquivo;

          if (documentoDemanda?.data_arquivo > dataEstimativaConclusao) {
            alert("A data de estimativa de conclusão deve ser posterior a data do arquivo!\nSubstitua o arquivo com a nova data.");
            formRef.current?.setFieldValue("arquivo_data", "");
            formRef.current?.setFieldValue("data_previsao_conclusao", "");
            setEstimativaDatas({
              ...estimativaDatas,
              dataInicio: "",
              dataFim: "",
            });
            return;
          };
        };

        console.log("data", data);
        updateProtocolo(protocoloId, data);
      } catch (err) {

      }
    }, [valueLocal, solicitante, origemSolicitante, documentoDemanda, solicitanteComitesBack, solicitanteComitesFront]
  );

  const differenceDate = () => {
    if (estimativaDatas.dataInicio === "" || estimativaDatas.dataFim === "") {
      return "Preencha ambas as datas para calcular a estimativa";
    }

    const dataInicio = new Date(estimativaDatas.dataInicio);
    const dataFim = new Date(estimativaDatas.dataFim);

    if (dataFim < dataInicio) {
      return "Data de Conclusão anterior à Data de Início"
    }

    const diferencaEmMilissegundos = Math.abs(
      dataFim.getTime() - dataInicio.getTime()
    );

    const differenceDate = Math.floor(
      diferencaEmMilissegundos / (1000 * 60 * 60 * 24)
    );

    return `${differenceDate} dias`;
  };

  const handleChangeLocal = (localSelected) => {
    setValueLocal(localSelected.target.value);
    setSolicitanteComitesFront([])
    if (protocolo?.demand_comittees) {
      setSolicitanteComitesBack(solicitanteComitesInitial.map((el) => ({ _destroy: el.id, id: el.id, comitteeId: el.comittee_id })));
    } else {
      setSolicitanteComitesBack([]);
    }
    formRef.current.setFieldValue("representative_id", "");
    formRef.current.setFieldValue("solicitante_id", "");
    formRef.current.setFieldValue("external_requester_id", "");
  };

  const handlerDocument = () => {
    const tituloArquivo = formRef.current?.getFieldValue("arquivo_titulo");
    const dataArquivo = formRef.current?.getFieldValue("arquivo_data");
    const nomeArquivo = formRef.current?.getFieldValue("arquivo_nome");
    if (!tituloArquivo) {
      alert("Insira o nome do Documento");
      return;
    } else if (!dataArquivo) {
      alert("Insira a data do Documento");
      return;
    } else if (!nomeArquivo) {
      alert("Insira o arquivo do Documento");
      return;
    };
    setDocumentoDemanda({ id: Date.now(), titulo_arquivo: tituloArquivo, data_arquivo: dataArquivo, nome_arquivo: nomeArquivo, isNew: true })
  };

  const handleAdicionarComite = () => {
    if (!solicitante || !comite) {
      alert("Selecione o Solicitante/Comitê");
      return;
    }
    if (solicitanteComitesFront?.find((o) => o.id == comite?.value)) {
      alert("Comitê já adicionado");
      return;
    };

    setSolicitanteComitesFront([...solicitanteComitesFront,
    { id: comite?.value, solicitante: solicitante?.nome, origem: solicitante?.tabela == 'representatives' ? "Representante" : "Funcionário", comite: comite?.label }]);

    const initialComite = solicitanteComitesInitial.find((el) => el.comittee_id === comite.value);
    console.log(initialComite);
    if (initialComite) {
      console.log("comitesBack", solicitanteComitesBack)
      console.log("if");
      console.log("comite", comite);
      console.log(solicitanteComitesBack.filter((el) => el.comitteeId !== comite.value));
      setSolicitanteComitesBack(solicitanteComitesBack.filter((el) => el.comitteeId !== comite.value));
    } else {
      setSolicitanteComitesBack([...solicitanteComitesBack, { comittee_id: comite.value, comiteLabel: comite.label }]);
    }
  };


  const dataTitleSolicitanteComite: GridColDef[] = [
    { field: "solicitante", headerName: "Solicitante", flex: 2 },
    { field: "origem", headerName: "Origem", flex: 1 },
    { field: "comite", headerName: "Comitê", flex: 2 },
    {
      field: "action",
      headerName: "Ações",
      description: "Ações por coluna.",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <Button
            variant="text"
            onClick={(e) => onDeleteSolicitanteComite(e, params.row)}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash-can" />
          </Button>
        );
      },
    },
  ];

  function onDeleteSolicitanteComite(e: any, row: any): void {
    setSolicitanteComitesFront(solicitanteComitesFront?.filter((el) => el.comite !== row.comite));
    setSolicitanteComitesBack((prevComitesBack) => {
      const destroyId = solicitanteComitesInitial.find((el) => el.comittee_id === row.id)

      let updatedComitesBack = [...prevComitesBack];

      if (destroyId?.demand_id) {
        updatedComitesBack = [
          ...prevComitesBack,
          { _destroy: destroyId.id, id: destroyId.id, comitteeId: destroyId.comittee_id }
        ];
      }

      return updatedComitesBack;
    });
  };

  const dataTitleDocumento: GridColDef[] = [
    {
      field: "data_arquivo",
      headerName: "Data do Documento",
      flex: 1,
      headerClassName: "header_table",
    },
    {
      field: "titulo_arquivo",
      headerName: "Nome do Documento",
      flex: 3,
      headerClassName: "header_table",
    },
    {
      field: "action",
      headerName: "Ações",
      description: "Ações por coluna.",
      sortable: false,
      flex: 1,
      headerClassName: "header_table",
      renderCell: (params) => {
        return (
          <>
            {!params.row.isNew ?
              <Link to={{ pathname: `${params.row.url_arquivo}/${params.row.nome_arquivo}` }} target="_blank">
                <Button variant="text">
                  <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
                </Button>
              </Link>
              :
              <Button variant="text">
                <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
              </Button>
            }
          </>
        );
      }
    }
  ];

  return (
    <div style={{margin: "0px", padding: "0px"}}>
    {
      isVisitante ? <>Você não tem permissão para acessar esse módulo.</> :
    
    <Container>
      <Form id="formProtocolo" ref={formRef} onSubmit={handleSubmit}>
        <Title color="#333">
          <span>Edição de Protocolo</span>
        </Title>

        <Panel titulo="Identificação">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Data da entrada:</TextTitle>
              <Input
                name="data_entrada"
                type="date"
                disabled
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Selecione de onde está vindo essa demanda:</TextTitle>
              <Radio name="local" options={demanda_options} onChange={handleChangeLocal} required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Organização:</TextTitle>
              <SelectInput
                name="organization_id"
                placeholder="Selecione..."
                options={organizeDataComCodigo(orgaos.data)}
                onInputChange={(e) => {
                  getOrganizations([{ label: "nome", value: e }, { label: 'ativo', value: true }]);
                }}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Despesa:</TextTitle>
              <SelectInput
                name="expense_type_id"
                placeholder="Selecione..."
                options={organizeDataComCodigo(despesas.data)}
                onInputChange={(e) => {
                  getDespesas([{ label: "nome", value: e }, { label: 'ativo', value: true }]);
                }}
                required
              />
            </Grid>
            {/* <Grid xs={12}>
              <TextTitle>A demanda será um rateio?</TextTitle>
              <Radio name="rateio" options={rateio_options} required />
            </Grid> */}
            <Grid xs={12}>
              <TextTitle>Instância:</TextTitle>
              <SelectInput
                name="protocol_instance_id"
                placeholder="Selecione..."
                options={organizeDataSelect(instanciasProtocolo.data, "id", "nome")}
                onInputChange={e => { getInstanciasProtocolo([{ label: 'nome', value: e }, { label: 'ativo', value: true }]) }}
                required
              />
            </Grid>
            {valueLocal == 'interno' ?
              <>
                <Grid xs={12}>
                  <TextTitle>Solicitante:</TextTitle>
                  <SelectInput
                    name="solicitante"
                    placeholder="Selecione..."
                    options={organizeDataSolicitante(solicitantesProtocolo)}
                    onInputChange={(e) => {
                      getSolicitantesProtocolo([{ label: "nome", value: e }, { label: 'ativo', value: true }]);
                    }}
                    onChange={(solicitante) => {
                      setSolicitante(solicitante);
                      setOrigemSolicitante(solicitante.tabela);
                      formRef.current?.clearField("comittee");
                    }}
                    required
                    isDisabled={solicitanteComitesFront?.length > 0}
                  />
                </Grid>
                <Grid xs={8}>
                  <TextTitle>Comitê:</TextTitle>
                  <SelectInput
                    name="comittee"
                    placeholder="Selecione..."
                    options={organizeDataComittee(comites.data)}
                    onChange={(comite) => {
                      setComite(comite);
                    }}
                  />
                </Grid>
                <Grid xs={4}>
                  <ButtonAdd style={{ marginTop: "28px" }} type="button" onClick={handleAdicionarComite}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                  </ButtonAdd>
                </Grid>
                {solicitanteComitesFront?.length > 0 && (
                  <Grid xs={12}>
                    <SecondaryTable
                      columsData={dataTitleSolicitanteComite}
                      rowsData={solicitanteComitesFront}
                      getRowId={(row) => row.comite}
                    />
                  </Grid>
                )}
              </>
              : valueLocal == 'externo' ?
                <Grid xs={12}>
                  <TextTitle>Solicitante:</TextTitle>
                  <SelectInput
                    name="external_requester_id"
                    placeholder="Selecione..."
                    options={organizeDataSolicitanteExterno(solicitantesExternos.data)}
                    onInputChange={e => { getSolicitantesExternos([{ label: 'nome', value: e }, { label: 'ativo', value: true }]) }}
                    onChange={(solicitante) => {
                      setSolicitante(solicitante);
                      setOrigemSolicitante("external_requester");
                    }}
                    required
                  />
                </Grid>
                : null}
          </Grid>
        </Panel>

        <Panel titulo="Documento">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Nome do documento:</TextTitle>
              <Input name="arquivo_titulo" type="text" defaultValue={protocolo?.titulo_arquivo} />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Data do documento:</TextTitle>
              <Input name="arquivo_data" type="date" defaultValue={protocolo?.data_arquivo}
                onChange={(dataDocumento) =>
                  setEstimativaDatas({
                    ...estimativaDatas,
                    dataInicio: dataDocumento.target.value,
                  })}
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Insira o documento referente a demanda:</TextTitle>
              <InputFilev2 name="arquivo_nome" />
            </Grid>
            <Grid xs={12}>
              <ButtonAdd type="button" onClick={handlerDocument}><FontAwesomeIcon icon={faPlus} /> Substituir o arquivo</ButtonAdd>
            </Grid>
            {documentoDemanda?.id && (
              <Grid xs={12}>
                <SecondaryTable
                  columsData={dataTitleDocumento}
                  rowsData={[documentoDemanda]}
                />
              </Grid>
            )}
          </Grid>
        </Panel>

        <Panel titulo="Demanda">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Origem demanda:</TextTitle>
              <SelectInput
                name="demand_origin_id"
                placeholder="Selecione..."
                options={organizeDataSelect(origensDemanda.data, "id", "nome")}
                onInputChange={e => { getOrigensDemanda([{ label: 'nome', value: e }, { label: 'ativo', value: true }]) }}
                required
              />
            </Grid>
            <Grid xs={12}>
              <TextTitle>Demanda:</TextTitle>
              <Input name="demanda" defaultValue={protocolo?.demanda} required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Tipo de encaminhamento:</TextTitle>
              <SelectInput
                name="forwarding_type_id"
                placeholder="Selecione..."
                options={organizeDataComCodigo(tiposEncaminhamento.data)}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Situação:</TextTitle>
              <SelectInput
                name="situacao"
                placeholder="Selecione..."
                options={situacao_options}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Responsável pela demanda:</TextTitle>
              <SelectInput
                name="user_id"
                placeholder="Selecione..."
                options={organizeDataSelect(usuariosByCargo.data, "id", "nome")}
                onInputChange={(e) => {
                  getUsuariosByCargo(e);
                }}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Data estimada de conclusão:</TextTitle>
              <Input
                name="data_previsao_conclusao"
                type="date"
                onChange={(dataEstimativa) =>
                  setEstimativaDatas({
                    ...estimativaDatas,
                    dataFim: dataEstimativa.target.value,
                  })}
                defaultValue={protocolo?.data_previsao_conclusao}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Estimativa em dias:</TextTitle>
              <Input disabled name="estimativa_dias" value={differenceDate()} />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Observação">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Observação:</TextTitle>
              <Textarea name="observacao" defaultValue={protocolo?.observacao} />
            </Grid>
          </Grid>
        </Panel>
      </Form>

      <ContainerButton>
        <Link to="/protocolo">
          <button>
            <FontAwesomeIcon icon={faX} size="1x" /> Cancelar
          </button>
        </Link>
        <button type="submit" form="formProtocolo">
          <FontAwesomeIcon icon={faSave} /> Salvar
        </button>
      </ContainerButton>
    </Container>
    }
    </div>
  )
};

export default ProtocoloEdit;